<div class="channel-container">
  <div class="icon-container" *ngIf="!hideIcon">
    <capra-icon class="channel-icon" [icon]="icon"></capra-icon>
    <ng-content></ng-content>
  </div>
  <div class="field-container" [class.full-width]="hideIcon">
    <mode-channel-drop-zone
      [channelSummary]="channelSummary"
      [encoding]="encoding"
      [model]="model"
      [view]="view"
      [chartService]="chartService"
      [chartType]="chartType"
      [series]="series"
      [queryToken]="queryToken"
      [vizToken]="vizToken"
      [fieldFormatMap]="fieldFormatMap"
      [binSizeToFieldMap]="binSizeToFieldMap"
      [format]="format"
      [allowScalars]="allowScalars"
      [allowAggregates]="allowAggregates"
      [allowDiscrete]="allowDiscrete"
      [allowContinuous]="allowContinuous"
      [allowBinned]="allowBinned"
      [requiresContinuous]="requiresContinuous"
      [showColorSettings]="showColorSettings"
      [useMeasureNamesPill]="useMeasureNamesPill"
      (dragStart)="onDragStart()"
      (dragEnd)="onDragEnd()"
      (dropOnField)="onDropOnField()"
      (dropOnEmpty)="onDropOnEmptyChannel()"
      (typeaheadSelection)="onTypeAheadSelection($event)"
      (fieldUpdated)="onFieldUpdated($event)"
      (removeField)="onRemoveField($event)"
      (removeMultiple)="onRemoveMultiple()"
      (removeSort)="onRemoveSort($event)"
      (setLegendSplit)="onSetSplitLegend($event)"
      (getBinSize)="getBinSize($event)"
    ></mode-channel-drop-zone>
  </div>
</div>
